window.AssetsUploader = require('./uploadFeeHandler');